/** Credits and tokens are different units, and confusing them is expensive.
 *
 * One credit buys 100 tokens of AI work. A super-admin typing "1000000" into
 * the allowance field meaning *tokens* grants a hundred million — which is
 * exactly what happened on the first real tenant, and nobody noticed because
 * the two numbers are never shown together.
 *
 * So: wherever a credit figure is shown, show what it buys.
 */

/** "≈ 99,976,700 tokens" — grouped for the reader, not the machine. */
export function tokensFor(credits: number, tokensPerCredit: number): number {
  return Math.max(0, Math.round(credits * tokensPerCredit));
}

/** Group a whole number the way the reader's locale does. */
export function grouped(n: number): string {
  return new Intl.NumberFormat().format(n);
}
